import LocalActivityIcon from '@mui/icons-material/LocalActivity';
// ==============================|| DASHBOARD MENU ITEMS ||============================== //

const ambassadorClaims = {
    id: 'ambassadorClaims',
    // title: 'Dashboard',
    type: 'group',
    children: [
        {
            id: 'ambassadorClaims',
            title: 'Ambassador Claims',
            type: 'item',
            url: '/ambassadorClaims',
            icon: LocalActivityIcon,
            breadcrumbs: false
        }
    ]
};

export default ambassadorClaims;
